export const services = {
  state: {
    serviceId: null,
    serviceList: []
  },
  mutations: {
    setServiceId(state, val) {
      state.serviceId = val
    },
    setServiceList(state, val) {
      state.serviceList = val
    }
  },
  getters: {
    serviceId(state) {
      return state.serviceId
    },
    serviceList(state) {
      return state.serviceList
    },
    serviceName(state) {
      const selectedService = state.serviceList.find(it => it.id === state.serviceId)
      if (selectedService === undefined) {
        return ''
      }
      return selectedService.name
    },
    servicePrice(state) {
      const selectedService = state.serviceList.find(it => it.id === state.serviceId)
      if (selectedService === undefined) {
        return ''
      }
      return `${selectedService.price}₽`
    },
    serviceInfo(state) {
      const selectedService = state.serviceList.find(it => it.id === state.serviceId)
      if (selectedService === undefined) {
        return ''
      }
      return `${selectedService.name} (${selectedService.price} ₽)`
    }
  }
}